const appliedUploads = new Set<string>();

/** Whether this page's demo uploads have added a loan account to an initially unlinked employee. */
export const hasDemoUploadedLoans = () => appliedUploads.size > 0;

/** Records local loan reflection; failed or deleted uploads remove their own account state. */
export function setDemoLoanUploadApplied(id: string, applied: boolean) {
  if (applied) appliedUploads.add(id);
  else appliedUploads.delete(id);
}

/** Clears local loan reflection when the demo upload session is reset. */
export const resetDemoUploadedLoans = () => appliedUploads.clear();
